import { AvailableModules, Features } from 'generated/featureDefinitions'
import { GetFeatureAvailabilitiesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { isFeatureAvailabilityEnabled } from 'modules/core/lib/isFeatureAvailabilityEnabled'

export const useLeaveRecommendationFeatureFlag = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { loading, data } = useQuery(GetFeatureAvailabilitiesDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      modules: [AvailableModules.timeoff],
      companyId,
    },
  })

  if (loading) {
    return { loading: true, enabled: false }
  }

  const featureAvailabilities = data?.companies.featureAvailabilities || []

  const enabled = isFeatureAvailabilityEnabled(
    featureAvailabilities,
    Features.timeoff_leaves_approval_recommendation
  )

  return { loading, enabled }
}
